var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeometryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.86 12H0L1.56 7H2.93V8H2.3L1.36 11H10.5L9.56 8H8.93V7H10.3L11.86 12ZM6.93 3.5C6.93 2.94772 6.48228 2.5 5.93 2.5C5.37772 2.5 4.93 2.94772 4.93 3.5C4.93 4.05228 5.37772 4.5 5.93 4.5C6.48228 4.5 6.93 4.05228 6.93 3.5ZM5.575 9.355C5.45 9.225 2.43 6.175 2.43 3.5C2.43 1.567 3.997 0 5.93 0C7.863 0 9.43 1.567 9.43 3.5C9.43 6.175 6.43 9.225 6.285 9.355L5.93 9.705L5.575 9.355ZM3.43 3.5C3.43 5.275 5.165 7.415 5.93 8.265C6.695 7.41 8.43 5.265 8.43 3.5C8.43 2.11929 7.31071 1 5.93 1C4.54929 1 3.43 2.11929 3.43 3.5Z",
    fill: "#5E81F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeometryIcon);
export default __webpack_public_path__ + "static/media/geometryIcon.1c40e323b662abaf770eac799a119176.svg";
export { ForwardRef as ReactComponent };